import jsonTokens from '@lualtek/tokens/web/tokens.json';
import constate from 'constate';
import { useCallback, useEffect, useState } from 'react';
const DEFAULT_BREAKPOINTS = {
    extraSmall: jsonTokens.breakpoint['extra-small'].em,
    small: jsonTokens.breakpoint.small.em,
    medium: jsonTokens.breakpoint.medium.em,
    large: jsonTokens.breakpoint.large.em,
    extraLarge: jsonTokens.breakpoint['extra-large'].em,
    wide: jsonTokens.breakpoint.wide.em,
};
const breakpointKeys = Object.keys(DEFAULT_BREAKPOINTS);
const DEFAULT_BREAKPOINTS_MATCHES = {
    extraSmall: false,
    small: false,
    medium: false,
    large: false,
    extraLarge: false,
    wide: false,
};
const matchMediaFactory = (breakpointKey) => window.matchMedia(`(${DEFAULT_BREAKPOINTS[breakpointKey]} <= width)`);
const useResponsive = () => {
    const [matches, setMatches] = useState(DEFAULT_BREAKPOINTS_MATCHES);
    const onChange = useCallback((key) => (event) => setMatches(old => ({ ...old, [key]: event.matches })), []);
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const results = breakpointKeys.reduce((acc, src) => {
            acc[src] = matchMediaFactory(src).matches;
            return acc;
        }, {});
        setMatches(results);
    }, []);
    useEffect(() => {
        const mediaQueryList = breakpointKeys.reduce((acc, src) => {
            acc[src] = matchMediaFactory(src);
            acc[src].addEventListener('change', onChange(src));
            return acc;
        }, {});
        return () => {
            Object.keys(mediaQueryList).forEach(src => mediaQueryList[src].removeEventListener('change', onChange(src)));
        };
    }, [onChange]);
    return { matches };
};
export const [ResponsiveProvider, useResponsiveContext,] = constate(useResponsive);
